module.exports = __webpack_public_path__ + "img/同济大学-300x300.0fe2d406.jpg";